import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OfferService } from '../../_services/offer.service';
import { User } from '../../_models/user';

@Component({
    selector: 'app-sales-list',
    templateUrl: './sales-list.component.html',
    styleUrls: ['./sales-list.component.css'],
    standalone: false
})
export class SalesListComponent implements OnInit {
    sales: any[] = [];
    loading = true;
    error = false;
    page = 1;
    totalItems = 0;
    itemsPerPage = 15;
    user: User;

    constructor(
        private offerService: OfferService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    }

    ngOnInit(): void {
        this.loadSales();
    }

    loadSales(): void {
        this.loading = true;
        this.error = false;
        this.offerService.getAllSales(this.page).subscribe({
            next: (response: any) => {
                const paginatedData = response?.data || response;
                this.sales = paginatedData?.data || [];
                this.totalItems = paginatedData?.totalOfItems || 0;
                this.itemsPerPage = paginatedData?.itemPerPage || 15;
                this.loading = false;
            },
            error: () => {
                this.sales = [];
                this.error = true;
                this.loading = false;
            }
        });
    }

    onPageChange(page: number): void {
        this.page = page;
        this.loadSales();
    }

    viewSale(sale: any): void {
        this.router.navigate(['/user', this.user.id, 'sales', sale.id]);
    }

    getCustomerName(sale: any): string {
        if (!sale.customer) {
            return '-';
        }
        const firstName = sale.customer.firstName || '';
        const lastName = sale.customer.lastName || '';
        return `${firstName} ${lastName}`.trim() || '-';
    }

    getProductName(sale: any): string {
        return sale.product?.productName || '-';
    }

    getStatusClass(status: string): string {
        switch (status?.toUpperCase()) {
            case 'PENDING': return 'badge bg-warning text-dark';
            case 'VALIDATED': return 'badge bg-success';
            case 'IN_PREPARATION': return 'badge bg-info';
            case 'SHIPPED': return 'badge bg-primary';
            case 'DELIVERED': return 'badge bg-success';
            case 'CANCELLED': return 'badge bg-danger';
            default: return 'badge bg-secondary';
        }
    }

    getStatusLabel(status: string): string {
        if (!status) return 'sales.status_pending';
        return 'sales.status_' + status.toLowerCase();
    }

    formatDate(dateString: string): string {
        if (!dateString) {
            return '-';
        }
        return new Date(dateString).toLocaleDateString();
    }
}
